var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-row"},[_c('ul',{staticClass:"d-flex flex-row"},[_c('li',{staticClass:"ml-5"},[_vm._v("Términos y condiciones")]),_c('li',{staticClass:"ml-5"},[_vm._v("Política de privacidad")])])])])
}]

export { render, staticRenderFns }